import { createApp } from 'vue'
import store from '../vuex'
import PaymentQrModal from "~/src/components/modals/PaymentQrModal.vue";
import CarGallery from '../components/gallery/CarGallery.vue'

export const UserAdvertisementShowView = {

  init() {
    const galleryEl = document.getElementById('car-gallery')
    if (galleryEl) {
      createApp(CarGallery, {
        photos: JSON.parse(galleryEl.dataset.photos),
        reserved: galleryEl.dataset.reserved === 'true',
        active: true,
      }).mount('#car-gallery')
    }

    // Mount Payment QR Modal
    const paymentModalWrapper = document.createElement('div');
    paymentModalWrapper.id = 'payment-qr-modal-wrapper';
    document.body.appendChild(paymentModalWrapper);

    createApp(PaymentQrModal)
      .use(store)
      .mount('#payment-qr-modal-wrapper');

    // Make store visible for payment-modal.js
    window.vueStore = store;
  },

}
